import { render, staticRenderFns } from "./LinkUs.vue?vue&type=template&id=70b3b66a&scoped=true&"
import script from "./LinkUs.vue?vue&type=script&lang=js&"
export * from "./LinkUs.vue?vue&type=script&lang=js&"
import style0 from "./LinkUs.vue?vue&type=style&index=0&id=70b3b66a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3b66a",
  null
  
)

export default component.exports